module.exports = __webpack_public_path__ + "img/pequ.ef95799d.jpg";